import { Link } from 'react-router-dom';

function BreadCrumbs({arr_breadcrumbs=[]}) {
    return (
        <>
            {arr_breadcrumbs.map((e, index)=>{
                if(e.link){
                    return (
                         <span key={index}>      
                            <Link to={e.link}>{e.name}</Link>&ensp;
                            {arr_breadcrumbs.length-1 > index && 
                                <>
                                    &ensp;<img className="img_breadcrumbs" src="./dashboard/breadcrumbs.svg" alt="" />&ensp;
                                </>
                            }
                        </span>
                    );
                }
                return (
                    <span key={index}>      
                        {e.name}
                        {arr_breadcrumbs.length-1 > index && 
                            <>
                                &ensp;<img className="img_breadcrumbs" src="./dashboard/breadcrumbs.svg" alt="" />&ensp;
                            </>
                        }
                    </span>
                );
            })}   
        </>
    );
}

export default BreadCrumbs;